import { useSnackbar } from 'notistack';
import React from 'react';
import { useCommandGetDiagnostics } from '../../../../../../../../app/ApiGen';
import type { DialogProps } from '../../../../../../../../components/Dialog';
import { Dialog } from '../../../../../../../../components/Dialog';
import type { FormField, OnSubmit } from '../../../../../../../../design-system';
import { Form } from '../../../../../../../../design-system';
import { useChargePoint } from '../../../Provider';
import { GetDiagnosticsDialogFields, validationSchema, WebhookDomain } from './getDiagnosticsForm';
import { useHandleError } from './useHandleError';

const DEFAULT_URL = `https://${WebhookDomain}/`;

const initialValues = { location: DEFAULT_URL };

const fields: FormField[] = [
  {
    id: 'location',
    label: 'Upload URL',
    inputProps: { helperText: 'URL where the diagnostics will be saved' },
  },
];

export const GetDiagnosticsDialog: React.FC<DialogProps> = ({ isOpen, onClose }) => {
  const { enqueueSnackbar } = useSnackbar();

  const { chargePoint, refetch } = useChargePoint();

  const { error, mutate } = useCommandGetDiagnostics({ id: chargePoint?.id ?? '' });

  useHandleError({ error, defaultErrorMessage: 'Unable to upload the charge point diagnostics' });

  const onSubmit = React.useCallback<OnSubmit<GetDiagnosticsDialogFields>>(
    async ({ location }, { setSubmitting }) => {
      try {
        const { data } = await mutate({ location });
        enqueueSnackbar(`Diagnostic command ${data.status.toLowerCase()}`);
        onClose();
        refetch();
      } finally {
        setSubmitting(false);
      }
    },
    [mutate, enqueueSnackbar, onClose, refetch],
  );

  return (
    <Dialog isOpen={isOpen} onClose={onClose} title="Get charge point diagnostics">
      <Form<GetDiagnosticsDialogFields>
        isEditing
        fields={fields}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        labels={{ save: 'Send command' }}
      />
    </Dialog>
  );
};
